import { defineMessages } from 'react-intl';

export const ReviewStepContent = defineMessages({
  sendOptions: {
    id: 'app.common.sendOptions',
    defaultMessage: 'Chceš tento záznam rovnou odeslat nebo jej máme uložit do paměti telefonu k pozdějšímu odeslání?',
  },
  sending: {
    id: 'app.common.sending',
    defaultMessage: 'Odesílám...',
  },
  send: {
    id: 'app.common.send',
    defaultMessage: 'Odeslat',
  },
  save: {
    id: 'app.common.save',
    defaultMessage: 'Uložit',
  },
  recordSentSuccess: {
    id: 'app.common.recordSentSuccess',
    defaultMessage: 'Záznam byl úspěšně odeslán',
  },
  recordSentError: {
    id: 'app.common.recordSentError',
    defaultMessage: 'Při odesílání záznamu došlo k chybě',
  },
  queuedMetersSentSuccess: {
    id: 'app.common.queuedMetersSentSuccessInstallation',
    defaultMessage: 'Instalace uložena, nezapomeňte ji odeslat na server pomocí synchronizačního tlačítka',
  },
});

export const ReviewStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  sending: {
    id: 'app.common.sending',
    defaultMessage: 'Odesílám...',
  },
  confirm: {
    id: 'app.common.confirm',
    defaultMessage: 'Potvrdit',
  },
});

export const InstallationDescriptions = defineMessages({
  title: {
    id: 'app.common.installation',
    defaultMessage: 'Instalace',
  },
  devEUISensor: {
    id: 'app.common.devEUISensor',
    defaultMessage: 'DevEUI senzoru',
  },
  meterMountTechnologyLabel: {
    id: 'app.common.meterMountTechnology',
    defaultMessage: 'Technologie osazení',
  },
});

export const PhotoDescriptions = defineMessages({
  title: {
    id: 'app.common.photoDescriptions',
    defaultMessage: 'Fotodokumentace',
  },
});

export const RegisterDescriptions = defineMessages({
  title: {
    id: 'app.common.register',
    defaultMessage: 'Register',
  },
  nameObis: {
    id: 'app.common.nameObis',
    defaultMessage: 'Název (OBIS)',
  },
  factor: {
    id: 'app.common.factor',
    defaultMessage: 'Impulzní konstanta',
  },
  inputChannel: {
    id: 'app.common.inputChannel',
    defaultMessage: 'Input/Kanál',
  },
  counter: {
    id: 'app.common.registerCounterPlaceholder',
    defaultMessage: 'Stav registru při osazení',
  },
  registerPhotos: {
    id: 'app.common.registerPhotos',
    defaultMessage: 'Fotky odečtu registru',
  },
});
